var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',[_c('feather-icon',{attrs:{"size":"21","icon":"RefreshCwIcon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }